import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, SimpleChanges, OnChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { MemberService } from '@app/services/member.service';
import { SnackbarService } from '@app/services/shared/snackbar.service';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import { PermissionsService } from '@app/services/permissions/permissions.service';
import moment from 'moment';
@Component({
  selector: 'app-membershipedit',
  templateUrl: './membershipedit.component.html'
})
export class MembershipeditComponent implements OnInit, OnDestroy, OnChanges {
  @Input() membership: any;
  enterexitcauses;
  editmembershipform;
  

  subscriptions: Subscription[] = [];
  minmaxyear = { minYear: '1720', maxYear: '2030' };
  autoCorrectedDatePipe = createAutoCorrectedDatePipe('yyyy-mm-dd', this.minmaxyear);
  public maskdatum = [/[129]/, /[?09]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
  @Output() closeEdit: EventEmitter<any> = new EventEmitter();
  selectedrole;

  constructor(
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private permissionService: PermissionsService,
    private institutionService: InstitutionsService,
    private memberService: MemberService,
    private snackbarService: SnackbarService) {
    this.getEntryExitCauses();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.membership) {
      this.editmembershipform.patchValue({ startDate: this.datePipe.transform(this.membership.startDate, 'yyyy-MM-dd') });
      if (this.membership.endCauseId) {
        this.editmembershipform.patchValue({ endDate: this.datePipe.transform(this.membership.endDate, 'yyyy-MM-dd') })
        this.editmembershipform.patchValue({ endCauseId: this.membership.endCauseId });
      } else {
        this.editmembershipform.patchValue({ endCauseId: null });
      }
      this.editmembershipform.patchValue({ startCauseId: this.membership.startCauseId });
      this.editmembershipform.patchValue({ institutionId: this.membership.institutionId });
      this.editmembershipform.patchValue({ memberId: this.membership.memberId });
      this.editmembershipform.patchValue({ membershipId: this.membership.id });
    }
  }
  ngOnInit() {
    this.editmembershipform = this.fb.group({
      membershipId: ['', ''],
      memberId: ['', ''],
      institutionId: ['', ''],
      startDate: ['', ''],
      startCauseId: ['', ''],
      endDate: ['', ''],
      endCauseId: ['', ''],
      action: ['update', '']
    });
    
    this.permissionService.selectedrole.subscribe(role => {
      this.selectedrole = role;
      if (this.selectedrole?.roleId === 12 || this.selectedrole?.roleId === 13) {
        this.minmaxyear.maxYear = '9999';
      }
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  setEndDate() {
    this.editmembershipform.patchValue({endDate: '9999-12-31'});
  }
  
  getEntryExitCauses() {
    this.subscriptions.push(this.institutionService.getEntryExitCauses().subscribe(response => {
      if (response) {
        this.enterexitcauses = response;
      }
    }));
  }

  close() {
    this.closeEdit.emit();
  }

  save() {
    const membershipdataarr = [];
    if (this.editmembershipform.get('startDate').dirty) {
      this.editmembershipform.patchValue({ startDate: moment(this.editmembershipform.get('startDate').value).add(3, 'h').format('YYYY-MM-DD HH:mm') });
    }
    if (this.editmembershipform.get('endDate').dirty) {
      this.editmembershipform.patchValue({ endDate: moment(this.editmembershipform.get('endDate').value).add(3, 'h').format('YYYY-MM-DD HH:mm') });
    }
    membershipdataarr.push(this.editmembershipform.value);
    this.subscriptions.push(this.memberService.updateMemberMembership(membershipdataarr).subscribe(response => {
      if (response) {
        this.snackbarService.openSnackBar('Medlemskapet uppdaterat', null);
        this.closeEdit.emit();
      }
    }));
  }
}
